import { CR_API_ENDPOINTS } from '../constants';
import { Disco, DiscoType } from '../types';
import { apiService } from './api.service';

class DiscoService {
  async getAllDisco(): Promise<Disco[]> {
    return apiService.get<Disco[]>(CR_API_ENDPOINTS.DISCO);
  }

  async getAvailableRatings(): Promise<number[]> {
    return apiService.get<number[]>(CR_API_ENDPOINTS.DISCO_RATINGS);
  }

  async getAvailableTypes(): Promise<string[]> {
    return apiService.get<string[]>(CR_API_ENDPOINTS.DISCO_TYPES);
  }

  async getDiscoByRatingAndType(rating: number, type: DiscoType): Promise<Disco[]> {
    return apiService.get<Disco[]>(CR_API_ENDPOINTS.DISCO_BY_RATING_TYPE, { 
      rating: rating.toString(), 
      type 
    });
  }

  async getFuseRatingsByDiscoRating(rating: number): Promise<number[]> {
    return apiService.get<number[]>(`${CR_API_ENDPOINTS.DISCO_FUSE_RATINGS}/${rating}`);
  }

  async getDiscoById(id: string): Promise<Disco> {
    return apiService.get<Disco>(`${CR_API_ENDPOINTS.DISCO}/${id}`);
  }

  async createDisco(discoData: {
    modelNumber: string;
    brand: string;
    discoRating: number;
    type: DiscoType;
    fuseRatings: number[];
  }): Promise<Disco> {
    return apiService.post<Disco>(CR_API_ENDPOINTS.DISCO, discoData);
  }
}

export const discoService = new DiscoService();